import { useLayoutEffect, useState } from 'react';

//https://codesandbox.io/p/sandbox/react-window-dynamic-row-height-8ftbq?file=%2Fsrc%2FuseWindowResize.js%3A9%2C6
const useWindowResize = () => {
    const [size, setSize] = useState([0, 0]);

    useLayoutEffect(() => {
        function updateSize() {
            setSize([window.innerWidth, window.innerHeight]);
        }

        window.addEventListener('resize', updateSize);
        updateSize();

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
};

export default useWindowResize;